import Fetcher from 'services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from 'constants/api'
import {
  HealthSystemCategoriesRequest,
  HealthSystemUsersRequest,
  HealthSystemUsersResponse
} from './types'
import { FilterListResponse } from '../../../types'

const fetcher = new Fetcher({})

export const getHealthSystemUsers = async (hsId, role, data) =>
  fetcher.request<HealthSystemUsersRequest, HealthSystemUsersResponse>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.USERS}${
      API_DICTIONARY.HEALTH_SYSTEM
    }${hsId}/${role ? role + '/' : ''}`,
    method: HTTP_METHODS.GET,
    version: 'v2',
    ...data
  })

export const getContractCategoriesListByRole = async (hsId, role) =>
  fetcher.request<HealthSystemCategoriesRequest, FilterListResponse>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.USERS}${
      API_DICTIONARY.HEALTH_SYSTEM
    }${hsId}/${role ? role + '/' : ''}${API_DICTIONARY.CONTRACT_CATEGORIES}`,
    method: HTTP_METHODS.GET
  })
